import apiFetch from '../../../utils/apiFetch';

export const commitTargetedCombatSave = async (campaignId, payload) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/saves/resolve`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok && !result.status) throw new Error(response.statusText || 'Saving throw could not be resolved.');
  return result;
};

export const standUp = async (campaignId, payload) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/conditions/prone/stand`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({id:window.crypto?.randomUUID?.()||`stand-${Date.now()}-${Math.random()}`,...payload}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.message || response.statusText || 'Could not Stand Up.');
    error.status = result.status;
    throw error;
  }
  return result;
};

export const createDefenderReactionOpportunity = async (campaignId, payload) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/reactions/opportunities`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || result.status || 'Reaction opportunity could not be created.');
  return result;
};

export const openHellishRebukeOffer = async (campaignId, payload) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/reactions/hellish-rebuke`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || 'Hellish Rebuke could not be offered.');
  return result;
};

export const decideDefenderReaction = async (campaignId, opportunityId, decision, featureId, details = {}) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/reactions/${encodeURIComponent(opportunityId)}/decide`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...details, decision, ...(featureId?{featureId}:{}) }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.message || result.status || 'Reaction decision could not be saved.');
    error.status = result.status;
    throw error;
  }
  return result;
};
